import { useEffect, useState } from 'react';
import { useGetMeQuery } from 'redux-store/api/auth';
import {
  useGetCurrentPaymentPlanQuery,
  useGetCustomerSecretMutation,
} from 'redux-store/api/billing';
import { useAppSelector } from 'redux-store/hooks/useAppSelector';
import { authSelector } from 'redux-store/selector';
import { getEnvironmentConfig } from 'utils/environment';

export const InAppNotifications = () => {
  const { isProduction } = getEnvironmentConfig();
  const { isAuth, companyId } = useAppSelector(authSelector);

  const [secretKey, setSecretKey] = useState('');
  const [show, setShow] = useState(false);

  const {
    data: userMe,
    isLoading: isUserMeLoading,
    error: userMeError,
  } = useGetMeQuery(undefined, {
    skip: !isAuth,
  });

  const { data: currentPaymentPlan } = useGetCurrentPaymentPlanQuery();
  const [getCustomerSecret, { data: customerSecretData }] = useGetCustomerSecretMutation();

  const inAppKey = process.env.REACT_APP_PK_IN_APP_NOTIFICATION_KEY;

  let pkUrl = '';
  const invoiceId = currentPaymentPlan?.invoiceId || '';

  if (isProduction) {
    pkUrl = 'https://app.paykickstart.com';
  } else {
    pkUrl = 'https://staging.paykickstart.com';
  }

  const iFrameSrc = `${pkUrl}/in-app/notifications/iframe/${inAppKey}/${secretKey}/${invoiceId}`;

  /**
   * Handle setting the secret key and showing the iframe from current payment plan data.
   */
  useEffect(() => {
    if (!userMe?.email) return;

    if (!currentPaymentPlan?.customerSecret) {
      getCustomerSecret({ data: { email: userMe?.email } }).then(({ data }) => {
        if (data?.secret) {
          setSecretKey(data.secret);
          setShow(true);
        }
      });
    } else {
      setSecretKey(currentPaymentPlan.customerSecret);
      setShow(true);
    }
  }, [currentPaymentPlan?.customerSecret, userMe?.email, getCustomerSecret]);

  /**
   * Load PayKickstart In-App Notification Script only when inAppKey and pkUrl are available and also
   * when the iframe is set to show.
   */
  useEffect(() => {
    if (!pkUrl || !inAppKey || !show) return;

    const script = document.createElement('script');
    script.src = `${pkUrl}/in-app/notifications/js/${inAppKey}`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [inAppKey, pkUrl, show]);

  if (!inAppKey) {
    return null;
  }

  return (
    show && (
      <iframe
        style={{
          width: '0px',
          height: '0px',
          zIndex: 999999999,
        }}
        src={iFrameSrc}
      />
    )
  );
};
